import { useEffect, useState } from 'react';
import './Testimonial.css';
import Carousel from '../../../components/Carousel/Carousel';
import ReactStars from 'react-stars'

import profile_1 from '../../../resources/Ellipse 158.png'
import profile_2 from '../../../resources/Ellipse 158.png'
import profile_3 from '../../../resources/Ellipse 158.png'
import profile_4 from '../../../resources/Ellipse 158.png'
import profile_5 from '../../../resources/Ellipse 158.png'
import food_1 from '../../../resources/Rectangle 641 (1).png'
import food_2 from '../../../resources/Rectangle 641 (2).png'
import food_3 from '../../../resources/Rectangle 641.png'

function Testimonial() {
    const [buttonClick, setButtonClick] = useState()
    const [feedback, setFeedback] = useState([])


    async function getFeedback() {
        const width = window.innerWidth
        let comp_in_div
        const tmp_array = []
        tmp_array.push(
            <div className='testimonial_indiv_feedback_div'>
                <div className='flex flex_column gap_10'>
                    <div className='flex align_center gap_10'>
                        <img src={profile_1} className='testimonial_indiv_feedback_profile_img' />
                        <div>
                            <p className='font_size_16 gray_scale_6 font_weight_500'>Avocado Toast</p>
                            <p className='font_size_14 gray_scale_2 font_weight_400'>Fitness Enthusiast</p>
                        </div>
                    </div>

                    <ReactStars count={5} value={5} size={20} color2={'#FE9539'} edit={false} />
                </div>

                <div className='flex flex_column gap_10'>
                    <p className='font_size_18 gray_scale_6 font_weight_500'>Feta Avocado Toast</p>
                    <p className='testimonial_indiv_feedback_text font_size_16 gray_scale_2 font_weight_400'>"I've always struggled to find the perfect balance between flavor and nutrition. The Feta Avocado Toast recipe from this app is a game-changer!</p>
                </div>

                <img src={food_1} className='testimonial_indiv_feedback_img' />
            </div>)
        tmp_array.push(
            <div className='testimonial_indiv_feedback_div'>
                <div className='flex flex_column gap_10'>
                    <div className='flex align_center gap_10'>
                        <img src={profile_2} className='testimonial_indiv_feedback_profile_img' />
                        <div>
                            <p className='font_size_16 gray_scale_6 font_weight_500'>Avocado Toast</p>
                            <p className='font_size_14 gray_scale_2 font_weight_400'>Fitness Enthusiast</p>
                        </div>
                    </div>

                    <ReactStars count={5} value={5} size={20} color2={'#FE9539'} edit={false} />
                </div>

                <div className='flex flex_column gap_10'>
                    <p className='font_size_18 gray_scale_6 font_weight_500'>Feta Avocado Toast</p>
                    <p className='testimonial_indiv_feedback_text font_size_16 gray_scale_2 font_weight_400'>"I've always struggled to find the perfect balance between flavor and nutrition. The Feta Avocado Toast recipe from this app is a game-changer!</p>
                </div>

                <img src={food_2} className='testimonial_indiv_feedback_img' />
            </div>)
        tmp_array.push(
            <div className='testimonial_indiv_feedback_div'>
                <div className='flex flex_column gap_10'>
                    <div className='flex align_center gap_10'>
                        <img src={profile_3} className='testimonial_indiv_feedback_profile_img' />
                        <div>
                            <p className='font_size_16 gray_scale_6 font_weight_500'>Avocado Toast</p>
                            <p className='font_size_14 gray_scale_2 font_weight_400'>Fitness Enthusiast</p>
                        </div>
                    </div>

                    <ReactStars count={5} value={5} size={20} color2={'#FE9539'} edit={false} />
                </div>

                <div className='flex flex_column gap_10'>
                    <p className='font_size_18 gray_scale_6 font_weight_500'>Feta Avocado Toast</p>
                    <p className='testimonial_indiv_feedback_text font_size_16 gray_scale_2 font_weight_400'>"I've always struggled to find the perfect balance between flavor and nutrition. The Feta Avocado Toast recipe from this app is a game-changer!</p>
                </div>

                <img src={food_3} className='testimonial_indiv_feedback_img' />
            </div>)
        tmp_array.push(
            <div className='testimonial_indiv_feedback_div'>
                <div className='flex flex_column gap_10'>
                    <div className='flex align_center gap_10'>
                        <img src={profile_1} className='testimonial_indiv_feedback_profile_img' />
                        <div>
                            <p className='font_size_16 gray_scale_6 font_weight_500'>Avocado Toast</p>
                            <p className='font_size_14 gray_scale_2 font_weight_400'>Fitness Enthusiast</p>
                        </div>
                    </div>

                    <ReactStars count={5} value={5} size={20} color2={'#FE9539'} edit={false} />
                </div>

                <div className='flex flex_column gap_10'>
                    <p className='font_size_18 gray_scale_6 font_weight_500'>Feta Avocado Toast</p>
                    <p className='testimonial_indiv_feedback_text font_size_16 gray_scale_2 font_weight_400'>"I've always struggled to find the perfect balance between flavor and nutrition. The Feta Avocado Toast recipe from this app is a game-changer!</p>
                </div>

                <img src={food_2} className='testimonial_indiv_feedback_img' />
            </div>)
        tmp_array.push(
            <div className='testimonial_indiv_feedback_div'>
                <div className='flex flex_column gap_10'>
                    <div className='flex align_center gap_10'>
                        <img src={profile_4} className='testimonial_indiv_feedback_profile_img' />
                        <div>
                            <p className='font_size_16 gray_scale_6 font_weight_500'>Avocado Toast</p>
                            <p className='font_size_14 gray_scale_2 font_weight_400'>Fitness Enthusiast</p>
                        </div>
                    </div>

                    <ReactStars count={5} value={5} size={20} color2={'#FE9539'} edit={false} />
                </div>

                <div className='flex flex_column gap_10'>
                    <p className='font_size_18 gray_scale_6 font_weight_500'>Feta Avocado Toast</p>
                    <p className='testimonial_indiv_feedback_text font_size_16 gray_scale_2 font_weight_400'>"I've always struggled to find the perfect balance between flavor and nutrition. The Feta Avocado Toast recipe from this app is a game-changer!</p>
                </div>

                <img src={food_1} className='testimonial_indiv_feedback_img' />
            </div>)
        tmp_array.push(
            <div className='testimonial_indiv_feedback_div'>
                <div className='flex flex_column gap_10'>
                    <div className='flex align_center gap_10'>
                        <img src={profile_5} className='testimonial_indiv_feedback_profile_img' />
                        <div>
                            <p className='font_size_16 gray_scale_6 font_weight_500'>Avocado Toast</p>
                            <p className='font_size_14 gray_scale_2 font_weight_400'>Fitness Enthusiast</p>
                        </div>
                    </div>

                    <ReactStars count={5} value={5} size={20} color2={'#FE9539'} edit={false} />
                </div>

                <div className='flex flex_column gap_10'>
                    <p className='font_size_18 gray_scale_6 font_weight_500'>Feta Avocado Toast</p>
                    <p className='testimonial_indiv_feedback_text font_size_16 gray_scale_2 font_weight_400'>"I've always struggled to find the perfect balance between flavor and nutrition. The Feta Avocado Toast recipe from this app is a game-changer!</p>
                </div>

                <img src={food_1} className='testimonial_indiv_feedback_img' />
            </div>)

        if (width < 970)
            comp_in_div = 1
        else if (width <= 1200)
            comp_in_div = 2
        else if (width < 1830)
            comp_in_div = 5
        else comp_in_div = 5

        const result = []
        const total = tmp_array.length

        for (let i = 0; i < total; i++) {
            const group = []
            for (let j = 0; j < comp_in_div; j++) {
                group.push(tmp_array[(i + j) % total]) // wrap around using modulo
            }

            result.push(
                <div key={i} className='flex align_center gap_32'>
                    {group}
                </div>
            )
        }

        setFeedback(result)
    }
    const handleResize = () => {
        getFeedback()
    };

    useEffect(() => {
        getFeedback()

        window.addEventListener('resize', handleResize);

        // Cleanup the event listener on component unmount
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <div className='testimonial_outer_div'>
            <div className='padding_top padding_bottom'>
                <div className='all_margin'>
                    <div className='margin_auto_width'>
                        <div>
                            <div className='features_heading_text text_align_center'>
                                <h1>Hear from Our Happy <span className='green_gradient_p'>Users</span></h1>
                                <p className='gray_scale_2 font_size_20 font_weight_400'>Discover how our app has transformed lives. Read the success stories from our satisfied users and see the difference it can make for you!</p>
                            </div>


                            <div className='testimonial_carousel_button_main_div flex gap_12 align_center'>
                                <div className={'dashboard-upcoming-meal-calendar-button-full-circle flex align_center justify_center cursor_pointer'}
                                    onClick={() => setButtonClick(-1)}
                                >
                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                                        <path d="M11 15L5 9L11 3" stroke="url(#paint0_linear_1_2093)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        <defs>
                                            <linearGradient id="paint0_linear_1_2093" x1="14" y1="11.625" x2="10.7448" y2="1.13302" gradientUnits="userSpaceOnUse">
                                                <stop stopColor="#235539" />
                                                <stop offset="1" stopColor="#7B946B" />
                                            </linearGradient>
                                        </defs>
                                    </svg>
                                </div>
                                <div className={'dashboard-upcoming-meal-calendar-button-full-circle cursor_pointer flex align_center justify_center'}
                                    onClick={() => setButtonClick(1)}
                                >
                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                                        <path d="M7 15L13 9L7 3" stroke="url(#paint0_linear_1_2096)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        <defs>
                                            <linearGradient id="paint0_linear_1_2096" x1="4" y1="11.625" x2="7.25521" y2="1.13302" gradientUnits="userSpaceOnUse">
                                                <stop stopColor="#235539" />
                                                <stop offset="1" stopColor="#7B946B" />
                                            </linearGradient>
                                        </defs>
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='testimonial_carousel_div'>
                    <Carousel array={feedback} hide_index disable_nav_button auto_slide interval={3000} buttonClick={buttonClick} setButtonClick={setButtonClick} />
                </div>
            </div>
        </div >
    );
}

export default Testimonial;
